import i18next from 'i18next';
import * as yup from 'yup';

export const postalCodeRegex = /^([A-Z]\d[A-Z]\s\d[A-Z]\d)/;

export const getPostalCodeSchema = (): yup.StringSchema =>
  yup
    .string()
    .matches(postalCodeRegex, { message: i18next.t('validation.error.postalCode'), excludeEmptyString: true });
